import { render, staticRenderFns } from "./Simple.vue?vue&type=template&id=bd6dfe04&scoped=true&"
import script from "./Simple.vue?vue&type=script&lang=js&"
export * from "./Simple.vue?vue&type=script&lang=js&"
import style0 from "./Simple.vue?vue&type=style&index=0&id=bd6dfe04&lang=scss&scoped=true&"
import style1 from "./Simple.vue?vue&type=style&index=1&id=bd6dfe04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd6dfe04",
  null
  
)

export default component.exports